/*
 * Modal functionality
 */

/**
 * Modal trigger functionality
 *
 * @param
 *
 * @return void
 */
export let __trigger_modal = async function () {
    let modal_opener_selector = '.js--modal-opener';
    let modal_closer_selector = '.js--modal-closer';
    let modal_selector = '.stmnt--modal';

    // Modal opener
    for (let modal_opener of $(modal_opener_selector)) {
        $(modal_opener).on('click', async function (event) {
            // Event prevent default
            event.preventDefault();

            let modal_id = $(this).attr('modal-id');
            if (modal_id && modal_id !== '') {
                let modal = $(modal_selector + '[modal-id="' + modal_id + '"]');
                if (!modal.length) {
                    return
                }
                let modal_closer = $(modal_closer_selector + '[modal-id="' + modal_id + '"]');

                $(modal).addClass('show');
                $(modal_closer).addClass('show');
                $('body').css('overflow-y', 'hidden');
            }
        });
    }

    // Modal closer
    for (let modal_closer of $(modal_closer_selector)) {
        $(modal_closer).on('click', async function (event) {
            // Event prevent default
            event.preventDefault();

            let modal_id = $(this).attr('modal-id');
            if (modal_id != '' && modal_id != undefined) {
                let modal = $(modal_selector + '[modal-id="' + modal_id + '"]');
                $(modal).removeClass('show');
                $(this).removeClass('show');
                $('body').css('overflow-y', '');
            }
        });
    }
};

/**
 * Share Modal trigger functionality
 *
 * @param
 *
 * @return void
 */
export let __trigger_share_modal = async function () {
    let modal_opener_selector = '.js--action-share';
    let modal_closer_selector = '.js--share-modal-closer';
    let share_modal_selector = '.stmnt--share-modal';

    // Modal opener
    $(modal_opener_selector).on('click', async function (event) {
        // Event prevent default
        event.preventDefault();

        $(share_modal_selector).removeClass('hidden');
    });

    // Modal closer
    $(modal_closer_selector).on('click', async function (event) {
        // Event prevent default
        event.preventDefault();

        $(share_modal_selector).addClass('hidden');
    });
};

export let __share_functions = async function () {
    let url_clean = $('.js--url-container').attr('data-url');
    $('.js--facebook-button').on('click', async function (event) {
        event.preventDefault();
        let url = encodeURIComponent(url_clean);
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, '_blank');
    });
    $('.js--twitter-button').on('click', async function (event) {
        event.preventDefault();
        let text = encodeURIComponent('VdW Geschäftsbericht');
        let url = encodeURIComponent(url_clean);
        window.open(
            'https://twitter.com/intent/tweet?text=' + text + '&url=' + url,
            '_blank'
        );
    });
    $('.js--mail-button').on('click', async function (event) {
        event.preventDefault();
        let subject = encodeURIComponent('VdW Geschäftsbericht');
        let body = encodeURIComponent('Schauen Sie sich diese Seite des VdW Geschäftsberichts an');
        window.open('mailto:?&body=' + body + '&subject=' + subject, 'share-email');
    });
    $('.js--link-button').on('click', async function (event) {
        event.preventDefault();
        if (navigator.clipboard != undefined) {
            navigator.clipboard.writeText(url_clean);
            console.log("hier2");
            if (!$(this).find('.js--copy-success').length > 0) {
                $(this).append(
                    '<span style="font-size:12px; color:white; text-align:center;" class="js--copy-success absolute top-12 left-0 right-0 ml-auto mr-auto">Erfolgreich kopiert</span>'
                );
            }
        }
        else {
            $(this).append(
                '<span style="font-size:12px; color:white; text-align:center;" class="js--copy-success absolute top-12 left-0 right-0 ml-auto mr-auto">Kopieren nicht möglich</span>'
            );
        }

        let that = this;
        setTimeout(async function () {
            $(that).find('.js--copy-success').remove();
            $(that).find('.js--copy-error').remove();
        }, 5000);
    });
};
